import { ENV } from "@/core/config/env";
import routeTenant from "@/core/services/routeTenant.service"

const baseUrlTenant = routeTenant.routeBaseConfig();

const business = [
    {
        path: baseUrlTenant,
        name: "business",
        component: () => import("@/view/layout/Layout"),
        children: [
            {
                path: "business-ancillary",
                name: "business-ancillary",
                component: () => import("@/view/pages/business/Ancillary")
            },
            {
                path: "business-cost",
                name: "business-cost",
                component: () => import("@/view/pages/business/Cost")
            },
            // {
            //     path: "business-cost-detail",
            //     name: "business-cost-detail",
            //     component: () => import("@/view/pages/business/DetailCost")
            // },
            {
                path: "business-cost-update",
                name: "business-cost-update",
                component: () => import("@/view/pages/business/UpdateCost")
            },
            {
                path: "business/category",
                name: "business-category",
                component: () => import("@/view/pages/business/Category")
            },
        ]
    },
]

export default business
